<template>
    <main-content v-if="$can('update-info','deposit-gateway')" with_go_back_bar>
        <kt-panel v-if="!loading">
            <kt-panel-body id="sheba_number_repeater">
                <form id="update_company_form">
                    <kt-row>
                        <kt-col lg="4" md="6" sm="12">
                            <kt-form-group>
                                <kt-form-label for="title">
                                    {{ $t('deposit.company_title') }}
                                </kt-form-label>
                                <kt-form-control
                                    id="title"
                                    name="title"
                                    v-model="company.title"
                                    class="form-control"
                                ></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="3" md="4" sm="12">
                            <kt-form-group>
                                <kt-form-label for="status">
                                    {{ $t('label.status') }}
                                </kt-form-label>
                                <kt-form-select
                                    id="status"
                                    name="status"
                                    v-model="company.status"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        value="0">
                                        {{ $t('label.inactive') }}
                                    </option>
                                    <option
                                        value="1">
                                        {{ $t('label.active') }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="3" md="4" sm="12">
                            <kt-form-group>
                                <kt-form-label for="wage_type">
                                    {{ $t('label.wage_type') }}
                                </kt-form-label>
                                <kt-form-select
                                    id="wage_type"
                                    name="wage_type"
                                    v-model="company.wage_type"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        value="1">
                                        {{ $t('deposit.normal_wage') }}
                                    </option>
                                    <option
                                        value="2">
                                        {{ $t('deposit.internal_wage') }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-form-action class="mt-4 float-right">
                        <button
                            id="submit_btn"
                            class="btn btn-md btn-success btn-wide"
                            @click.prevent="update"
                        >
                            {{ $t('btn.update') }}
                        </button>
                    </kt-form-action>
                </form>
                <kt-form-section data-repeater-list="sheba_numbers">
                    <p style="font-size: medium;margin: 30px 0">
                        {{ $t('deposit.company_accounts') }}
                    </p>
                    <div id="sheba_page"></div>
                    <kt-form-group hor data-repeater-item v-for="(account,index) in company.accounts" :key="index">
                        <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                            <kt-row>
                                <kt-col lg="9" md="9" sm="12" xs="12">
                                    <kt-form-group>
                                        <kt-form-label>
                                            {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                        </kt-form-label>
                                        <kt-input-group class="" id="sheba_number">
                                            <kt-form-control
                                                dir="ltr"
                                                :name="'accounts.'+index+'.sheba_number'"
                                                aria-describedby="national_code-error"
                                                :data-id="'accounts.'+index+'.sheba_number'"
                                                v-model="company.accounts[index].sheba_number"></kt-form-control>
                                            <kt-input-group-append class="ir-append">
                                                <kt-input-group-text>IR</kt-input-group-text>
                                            </kt-input-group-append>
                                            <kt-input-group-append v-if="company.accounts[index].sheba_number">
                                                <img height="38px"
                                                     :id="index"
                                                     :src="BankLogo(BankNameBySheba('IR'+ company.accounts[index].sheba_number))">
                                            </kt-input-group-append>
                                        </kt-input-group>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="9" md="9" sm="12" xs="12">
                                    <kt-form-group>
                                        <kt-form-label>
                                            {{ $t('label.account_number') }}
                                        </kt-form-label>
                                        <kt-input-group class="" id="account_number">
                                            <kt-form-control dir="ltr"
                                                             :name="'accounts.'+index+'.account_number'"
                                                             aria-describedby="national_code-error"
                                                             :data-id="'accounts.'+index+'.account_number'"
                                                             v-model="company.accounts[index].account_number"></kt-form-control>
                                        </kt-input-group>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </div>
                        <div
                            class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                            <kt-form-group>
                                <a @click="deleteAccount(index)"
                                   class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right my-2"
                                   :id="`delete_acc_btn_${index}`">
                                    <i class="la la-trash-o"></i>
                                    {{ $t('btn.delete') }}
                                </a>
                            </kt-form-group>
                            <kt-form-group>
                                <a @click="updateAccount(index)"
                                   class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-primary btn-bold float-right"
                                   :id="`update_acc_btn_${index}`">
                                    <i class="la la-pencil-square"></i>
                                    {{ $t('btn.edit') }}
                                </a>
                            </kt-form-group>
                        </div>
                    </kt-form-group>
                </kt-form-section>

                <kt-form-group hor>
                    <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                        <form id="add_new_account">
                            <kt-row>
                                <kt-col lg="9" md="9" sm="12" xs="12">
                                    <kt-form-group>
                                        <kt-form-label>
                                            {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                        </kt-form-label>
                                        <kt-input-group class="" id="new_sheba_number">
                                            <kt-form-control dir="ltr"
                                                             name="new_sheba_number"
                                                             aria-describedby="new_sheba_number-error"
                                                             data-id="new_sheba_number"
                                                             v-model="new_sheba_number"></kt-form-control>
                                            <kt-input-group-append class="ir-append">
                                                <kt-input-group-text>IR</kt-input-group-text>
                                            </kt-input-group-append>
                                            <kt-input-group-append v-if="new_sheba_number">
                                                <img height="38px"
                                                     :src="BankLogo(BankNameBySheba('IR'+new_sheba_number))">
                                            </kt-input-group-append>
                                        </kt-input-group>
                                    </kt-form-group>
                                    <kt-form-group>
                                        <kt-form-label>
                                            {{ $t('label.account_number') }}
                                        </kt-form-label>
                                        <kt-input-group class="" id="new_account_number">
                                            <kt-form-control dir="ltr"
                                                             name="new_account_number"
                                                             aria-describedby="new_account_number-error"
                                                             data-id="new_account_number"
                                                             v-model="new_account_number"></kt-form-control>
                                        </kt-input-group>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </form>
                    </div>
                    <div
                        class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                        <kt-form-group id="add_button">
                            <a @click="addAccount()"
                               id="add_account_btn"
                               class="btn btn-bold btn-sm btn-label-brand"
                            >
                                <i class="la la-plus"></i>
                                {{ $t('btn.add') }}
                            </a>
                        </kt-form-group>
                    </div>
                </kt-form-group>

            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>

import mainContent from '@/components/main-content'
import $ from "jquery";
import { depositPfService, depositStarshopService } from "@/common/api.service"
import {KTApp} from '@/plugins/core/app';
import {KTUtil} from '@/plugins/core/util'
import {i18n} from "@/plugins/i18n";
import Divider from "@/components/elements/dropdown/divider.vue";
import toastr from "toastr";
import Inputmask from "inputmask";
import Img from "@/components/elements/img.vue";

export default {
    components: {
        Img,
        Divider,
        mainContent
    },
    data() {
        return {
            company: {},
            loading: true,
            new_account_number: '',
            new_sheba_number: '',
            statuses: [
                {
                    value: 1,
                    title: i18n.t('label.active')
                }, {
                    value: 0,
                    title: i18n.t('label.inactive')
                }
            ],
            depositPfService,
            depositStarshopService
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
    },
    methods: {
        update() {
            let form = $('#update_company_form');
            let btn = $('#submit_btn');
            form.validate({
                rules: {
                    title: {
                        required: true,
                    },
                    status: {
                        required: true,
                    } ,
                    wage_type: {
                        required: true,
                    }
                },
            });
            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)
            let params = {
                status: this.company.status,
                title: this.company.title,
                wage_type: this.company.wage_type,
            }
            this.apiService.updateCompany(this.company.id, params).then(response => {
                return this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                if (response.data)
                    form.validate().showErrors(response.data.data);
                return this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        deleteAccount(index) {
            let btn = $('#delete_acc_btn_' + index);
            var result = confirm(i18n.t('deposit.message.remove_account'));
            if (!result) return;
            let params = {
                sheba_number: this.company.accounts[index].sheba_number,
                account_number: this.company.accounts[index].account_number,
                verified_company_id: this.company.id,
                account_id : this.company.accounts[index].id
            }
            KTApp.progress(btn)

            this.apiService.removeCompanyAccount(params).then(response => {
                this.toastr.success(response.data.message)
                this.company.accounts.splice(index, 1)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        updateAccount(index) {
            let btn = $('#update_acc_btn_' + index);
            var result = confirm(i18n.t('deposit.message.update_account'));
            if (!result) return;
            let new_sheba = 'IR' + this.company.accounts[index].sheba_number
            new_sheba = new_sheba.split('-').join('')
            new_sheba = new_sheba.split(' ').join('')
            new_sheba = new_sheba.split('_').join('')

            if (!this.isShebaValid(new_sheba))
                return this.toastr.error(i18n.t('deposit.message.sheba_is_not_valid'))

            for (var i = 0; i < this.company.accounts.length; i++) {
                if (this.company.accounts[i].account_number === this.company.accounts[index].account_number && i !== index)
                    return this.toastr.error(i18n.t('deposit.message.account_number_is_duplicate'))
                let sheba = 'IR' + this.company.accounts[i].sheba_number
                sheba = sheba.split('-').join('')
                sheba = sheba.split(' ').join('')
                sheba = sheba.split('_').join('')
                if (new_sheba === sheba && i !== index)
                    return this.toastr.error(i18n.t('deposit.message.sheba_number_is_duplicate'))
            }

            let params = {
                sheba_number: this.company.accounts[index].sheba_number,
                account_number: this.company.accounts[index].account_number,
                account_id: this.company.accounts[index].id,
                verified_company_id: this.company.id
            }
            KTApp.progress(btn)

            this.apiService.updateCompanyAccount(params).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        afterDispatch() {
            document.getElementById('sheba_number') && Inputmask('IR99-9999-9999-9999-9999-9999-99').mask(document.getElementById('sheba_number'))
        },
        IMask() {
            setTimeout(() => {
                Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#new_sheba_number input'))
            }, 1000);
            setTimeout(() => {
                Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#sheba_number input'))
            }, 1000);
        },
        addAccount() {
            let btn = $(`#add_account_btn`)

            let form = $('#add_new_account');

            form.validate({
                rules: {
                    new_sheba_number: {
                        required: true,
                    },
                    new_account_number: {
                        required: true,
                    }
                },
            });
            if (!form.valid()) {
                return
            }

            let new_sheba = 'IR' + this.new_sheba_number
            new_sheba = new_sheba.split('-').join('')
            new_sheba = new_sheba.split(' ').join('')
            new_sheba = new_sheba.split('_').join('')

            if (!this.isShebaValid(new_sheba))
                return this.toastr.error(i18n.t('deposit.message.sheba_is_not_valid'))

            for (var i = 0; i < this.company.accounts.length; i++) {
                if (this.company.accounts[i].account_number === this.new_account_number)
                    return this.toastr.error(i18n.t('deposit.message.account_number_is_duplicate'))
                let sheba = 'IR' + this.company.accounts[i].sheba_number
                sheba = sheba.split('-').join('')
                sheba = sheba.split(' ').join('')
                sheba = sheba.split('_').join('')
                if (new_sheba === sheba)
                    return this.toastr.error(i18n.t('deposit.message.sheba_number_is_duplicate'))
            }
            KTApp.progress(btn)
            let params = {
                sheba_number: new_sheba,
                account_number: this.new_account_number,
                verified_company_id: this.company.id
            }
            this.apiService.addCompanyAccount(params).then(response => {
                this.toastr.success(response.data.message)
                this.company.accounts.push({
                    sheba_number: new_sheba.split('IR').join(''),
                    account_number: this.new_account_number,
                })
                this.new_account_number = ''
                this.new_sheba_number = ''
                this.IMask()
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })

        },
    },
    mounted() {
        this.apiService.findCompany(this.$route.params.hashid).then(response => {
            this.company = response.data.data
            this.loading = false;
            this.IMask()
        })
    }
}
</script>

<style>
#add_button {
    margin-top: 30px;
    margin-right: -122px
}

.kt-input-icon > .kt-input-icon__icon.kt-input-icon__icon--left {
    top: -26px;
}

.ir-append {
    height: 38.2px!important;
}

@media screen and (max-width: 1024px) {
    .ir-append {
        height: 35.9px!important;
    }

}

@media screen and (max-width: 769px) {
    #add_button {
        margin-top: 0;
        margin-right: 0
    }
}

@media screen and (max-width: 681px) {
    .kt-input-icon > .kt-input-icon__icon.kt-input-icon__icon--left {
        top: -40px;
    }
}
</style>